var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.enabled
    ? _c("div", { staticClass: "cargo-ai-host" }, [
        _c(
          "div",
          {
            staticClass: "cargo-ai-ball",
            attrs: { title: _vm.isOpen ? "收起 AI 助手" : "AI 助手" },
            on: { click: _vm.togglePanel }
          },
          [
            _c(
              "svg",
              {
                staticClass: "cargo-ai-ball-icon",
                attrs: { viewBox: "0 0 24 24", width: "24", height: "24" }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M12 2l2.4 7.6L22 12l-7.6 2.4L12 22l-2.4-7.6L2 12l7.6-2.4z",
                    fill: "#fff"
                  }
                })
              ]
            )
          ]
        ),
        _c(
          "div",
          { staticClass: "cargo-ai-panel", class: { "is-open": _vm.isOpen } },
          [
            _vm.loading
              ? _c("div", { staticClass: "cargo-ai-loading" }, [
                  _c("div", { staticClass: "cargo-ai-loading-spinner" }),
                  _c("div", { staticClass: "cargo-ai-loading-text" }, [
                    _vm._v("正在加载 AI 助手…")
                  ])
                ])
              : _vm._e(),
            _vm.aiUrl
              ? _c("iframe", {
                  ref: "aiIframe",
                  staticClass: "cargo-ai-iframe",
                  attrs: {
                    title: "cargo-ai",
                    allow: "clipboard-write",
                    src: _vm.aiUrl
                  },
                  on: { load: _vm.onIframeLoad }
                })
              : _vm._e()
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }